import { getScrollFieldId, DATA_SCROLL_FIELD_ID_ATTR } from '../fields/scrollToField';
import { BaseFields } from '../fields/types';
import { walkFields } from '../fields/utils/walkFields';
import { getFormStoreSingleton } from '../store/store';
import { BaseValidationError } from '../types';
import { $internals, FormActionsMap, FormInstance } from './types';
import { scrollToFormError } from './scrollToFormError';
import { scrollToElement } from './scrollToElement';

export function scrollToFirstError<
    FormName extends string,
    FormFields extends BaseFields,
    FormValidationError extends BaseValidationError,
    FormContextInput,
    FormContext,
    FormActions extends FormActionsMap<FormFields, FormValidationError, FormContext>,
    FormSubmitArg,
    FormSubmitReturnValue,
>({
    form,
}: {
    form: FormInstance<
        FormName,
        FormFields,
        FormValidationError,
        FormContextInput,
        FormContext,
        FormActions,
        FormSubmitArg,
        FormSubmitReturnValue
    >;
}) {
    const { getFieldsState, getFormValue } = getFormStoreSingleton(form.name);

    const formValue = getFormValue({ formInitializationId: form[$internals].formInitializationId }) ?? {};
    const fieldsState = getFieldsState({ formInitializationId: form[$internals].formInitializationId }) ?? {};

    // Если блок ошибок формы найден, то прокручиваем страницу до него
    const formErrorScrolled = scrollToFormError({ formName: form.name, formId: form.id });

    if (formErrorScrolled) return;

    const fieldsWithErrors: string[] = [];

    // Собираем Id всех полей с ошибками
    walkFields({
        formValue,
        fields: form[$internals].fields,
        fieldsState,
        callback: (_, fieldId) => {
            const fieldState = fieldsState[fieldId];

            if (
                fieldState &&
                (fieldState?.errorsMap.onChange.length > 0 ||
                    fieldState?.errorsMap.onBlur.length > 0 ||
                    fieldState?.errorsMap.onSubmit.length > 0)
            ) {
                fieldsWithErrors.push(fieldId);
            }
        },
    });

    // CSS селектор для всех полей с ошибками
    const querySelector = fieldsWithErrors
        .map(
            fieldId =>
                `[${DATA_SCROLL_FIELD_ID_ATTR}="${getScrollFieldId({
                    fieldId,
                    formId: form.id,
                    formName: form.name,
                })}"]`
        )
        .join(', ');

    // TODO DIRECT-262772 Для "общих" ошибок формы реализовать селектор
    if (!querySelector) return;

    // querySelector вернет первый в DOM элемент
    const topElement = document.querySelector(querySelector);

    if (topElement) {
        scrollToElement(topElement);
    }
}
